module.exports = __webpack_public_path__ + "static/opener-text-710d91a2d6db1dde953ad85ff094d0e9.png";